<template>
<div>
    <Breadcrumb :title="'Issuance Upload'"></Breadcrumb>
    <div class="row no-gutters">
        <div class="col">
            <button class="btn btn-primary" style="float:right;" @click.prevent='downloadTemplate'> Download Template</button>
            <button class="btn btn-secondary" style="float:right;margin-right:10px;" @click.prevent='backtoIssuance'>
                <span class="k-icon k-i-undo" >  </span> &nbsp;Back to Issuance
                </button>
        </div>
    </div>
    <div class="row">
        <br>

</div>
        <BaseDropzone ref="ParentFileUploaded" :id="'Issuancedropzone'" :acceptedFileTypes="SheetJSFT" @change="_change" @Remove="ClearForm" :File="inputfile" :UploadType="FileUploadType"></BaseDropzone>
        <br><br>
        <div v-show="displayPage">
            <div class="row no-gutters">
                <div class="col">
                    <div id="customerrors" class="alert alert-danger" v-if="customerrors.length>0">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="error in customerrors" :key="error">{{ error }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
            <div class="row no-gutters">
                <div class="col">
                    <div class="form-row">
                        <div class="col-md-12">
                            <BaseGrid :mode="'editform'" :config="IssuanceUploadGridConfig" :data="dataIssuanceExcel" @DeleteItem="DeleteDIfromGrid">
                                <!-- @EditItem="EditPartner"  -->
                            </BaseGrid>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <br>

</div>
                <div class="row no-gutters" style='float: right;'>
                    <button type="button" id="btnSave" class="btn btn-primary"  :disabled="!isValid||customerrors.length>0||dataIssuanceExcel.length<=0" @click="SaveIssuance">Save</button>

                </div>
                 <div class="row no-gutters" style='float: right;'>
                    <button type="button" id="btnSave" class="btn btn-secondary" @click.prevent="validateIssuance">Validate</button>
                </div>
                <div class="row">
                    <br><br>

</div>
                </div>

            </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import sheetJSConfig from "@/configs/sheetJS.js";
import { isNullOrUndefined } from "util";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseDropzone from "@/components/base/BaseDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BaseProgram from '@/models/BaseModelProgram.js';
import BasePartner from '@/models/BaseModelPartner.js';
import BaseIssuance from '@/models/BaseModelIssuance.js';
import XLSX from "xlsx";
import BaseModelProgram from '@/models/BaseModelProgram.js';
import BaseModelPartner from '@/models/BaseModelPartner.js';
import BaseModelUnitClass from '@/models/BaseModelUnitClass.js';
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js"; 
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

import {
    mapActions,
    mapState,
    mapGetters
} from 'vuex';
import {
    IssuanceUploadGridConfig
} from '@/views/issuance/Issuanceuploadconfig.js'
import BaseModelDirectInvestmentValuation from '@/models/BaseModelDirectInvestmentValuation.js'

export default {
    components: {
        BaseGrid,
        Breadcrumb,
        BaseDropzone,
    },
    mixins: [apiUtil, funcUtil,VestingScheduleDatesMixin,DocumentManagerMixin],
    data() {
        return {
            data: "",
            inputfile: {
                UploadFile: {}
            },
            //UploadFile:excelfile,
            displayPage: false,
            FileUploadType: {
                AllowMultiple: "false"
            },
            SheetJSFT: sheetJSConfig.fileType,
            IssuanceUploadGridConfig: IssuanceUploadGridConfig,
            dataIssuanceExcel: [],
            PartnerAPIData: [],
            InvestmentAPIData: [],
            isValid:false,
            customerrors:[],
            dropdowns: {
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] },
        UnitPool:{ model: "", dataSource: []}
      },
       bulkUploadAuditConfig: bulkUploadAuditConfig
        };
    },
    computed: {
        ...mapState("postModule", ["response"]),
        ...mapGetters("getModule", ["getAllItemFilter","withFilter", "getAll","getLocalInputControls"])
    },
    methods: {
        ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
        _suppress(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        },
        downloadTemplate() {
            let token = localStorage.getItem("eum")
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("IssuanceExcel");
           let templateFileName = getFileName("IssuanceExcel");
            
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
        },

        _drop(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            const files = evt.BaseModelTransfer.files;
            if (files && files[0]) this._file(files[0]);
        },
        _change(evt) {
            const files = this.inputfile.UploadFile[0];
            if (files) this._file(files);
        },
        _export(evt) {
            /* convert state to workbook */
            const ws = XLSX.utils.aoa_to_sheet(this.data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
            /* generate file and send to client */
            XLSX.writeFile(wb, "sheetjs.xlsx");
        },
        backtoIssuance: function () {
            this.$router.push("/event/issuance");
        },
        _file(file) {
            /* Boilerplate to set up FileReader */
            try {
                const self=this;
                const XLSX = require("xlsx");
                const reader = new FileReader();
                reader.onload = e => {
                    /* Parse data */
                    //const bstr = e.target.result;
                    let binary = "";
                    let bytes = new Uint8Array(e.target.result);
                    let length = bytes.byteLength;

                    for (let i = 0; i < length; i++) 
                    {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    const bstr = binary
                    const wb = XLSX.read(bstr, {
                        type: "binary"
                    });
                    /* Get Partner  data */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, {
                        range: sheetJSConfig.template.header - 1, 
                        header: 1
                    });
                    console.log(data);
                    data.splice(0, 1);
                    if (data && data.length) {
                        //get partner and Program
                        let response = this.getAllItemFilter({
                            Partner: {
                                config: BasePartner
                            },
                            Program: {
                                config: BaseProgram
                            }

                        });
                        if (response) {
                            this.PartnerAPIData = response.Partner;
                            this.ProgramAPIData = response.Program;
                        }
                        //if (this.HeaderRow != "") {
                        this.displayPage = true;

                        var IssuanceExcelArr = [];
                        var count = 1;
                        for (var i = 0; i < data.length; i++) {
                            var IssuanceExcelObj = {};
                            IssuanceExcelObj.IssuanceKey = count++;
                            IssuanceExcelObj.ProgramProgramID = data[i][0];
                            IssuanceExcelObj.ReceiverReceiverID = data[i][2];

                            if (data[i][4]) {
                                IssuanceExcelObj.UnitClass =this._firstLetterToUpper(data[i][4].toString());
                            }
                            if (data[i][5]) {
                                IssuanceExcelObj.UnitType =this._firstLetterToUpper(data[i][5]) ;
                            }
                            if (data[i][6]) {
                                IssuanceExcelObj.VestingType =this._firstLetterToUpper(data[i][6]) ;
                            }
                            if(data[i][7])
                            {
                                IssuanceExcelObj.UnitPool =this._firstLetterToUpper(data[i][7]);
                            }
                            
                            IssuanceExcelObj.Unit = data[i][8];
                            IssuanceExcelObj.TransactionDate = self._getExcelPlatformCode(data[i][9]);
                                // moment(
                                //     new Date(Math.round((data[i][9] - 25569) * 86400 * 1000))
                                // ).format("MM/DD/YYYY");

                            IssuanceExcelObj.BusinessEvent = "Issuance";

                            IssuanceExcelObj.Status = "Pending";
                            //Get Vesting Dates                            

                            let VestingScheduleResponse = this.getAll(BaseModelVestingSchedule.list)
                                .filter(vestingschedule=>vestingschedule.ProgramID == IssuanceExcelObj.ProgramProgramID && vestingschedule.UnitClass == IssuanceExcelObj.UnitClass);
                            
                                
                            this._getVestingDates(IssuanceExcelObj,VestingScheduleResponse);
                            
                            this._updateHireDate(IssuanceExcelObj);
                            
                            IssuanceExcelArr.push(IssuanceExcelObj);
                        }
                        this.dataIssuanceExcel = IssuanceExcelArr;
                        this.getPartnerDetails();
                        this.getProgramDetails();

                        var grid = $("#IssuanceUploadGrid").data("kendoGrid");

                        grid.dataSource.data(this.dataIssuanceExcel);
                       
                        console.log(JSON.stringify(this.dataIssuanceExcel));
                    }
                    else{
                    this._AlertPopup("Template is Empty","error").then((result) => {
                    })
                    }

                    /* Update state */
                    //this.data = data;
                    //console.log(JSON.stringify(data));
                };
                reader.readAsArrayBuffer(file);
            } catch (ex) {
                console.log(ex);
                //this.$Progress.fail();
            }
        },
        getPartnerDetails: function () {
            let partner = this.PartnerAPIData.slice();
            let dataIssuanceExcel = this.dataIssuanceExcel.slice();

            for (let i = 0; i < dataIssuanceExcel.length; i++) {
                if (dataIssuanceExcel[i].ReceiverReceiverID) {
                    var result = partner.filter(function (obj) {
                        if (obj.PartnerID) {
                            return (obj.PartnerID.toString().trim().toLowerCase() == dataIssuanceExcel[i].ReceiverReceiverID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataIssuanceExcel[i].ReceiverFullName = result.FullName;
                        dataIssuanceExcel[i].ReceiverId = result.Id;
                    }
                }
            }

            this.dataIssuanceExcel = dataIssuanceExcel;

        },

        getProgramDetails: function () {
            let Program = this.ProgramAPIData.slice();
            let dataIssuanceExcel = this.dataIssuanceExcel.slice();

            for (let i = 0; i < dataIssuanceExcel.length; i++) {
                if (dataIssuanceExcel[i].ProgramProgramID) {
                    var result = Program.filter(function (obj) {
                        if (obj.ProgramID) {
                            return (obj.ProgramID.toString().trim().toLowerCase() == dataIssuanceExcel[i].ProgramProgramID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataIssuanceExcel[i].ProgramTitle = result.Title;
                        dataIssuanceExcel[i].ProgramAlias = result.Alias;
                        dataIssuanceExcel[i].ProgramId = result.Id;
                    }
                }
            }
            this.dataIssuanceExcel = dataIssuanceExcel;
        },

        DeleteDIfromGrid: function (e) {
            //e.preventDefault();
            //alert("Delete button clicked from BaseGrid..");
            const message = "Are you sure you want to delete this record?";
            this._ConfirmationPopup(message, "DELETE").then((result) => {
                if (result.value) {
                    var gview = window.$("#IssuanceUploadGrid").data("kendoGrid");
                    var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                    //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
                    //alert(JSON.stringify(dataItem));
                    let objIndex = this.dataIssuanceExcel.findIndex(
                        obj => obj.IssuanceKey == dataItem.IssuanceKey
                    );
                    this.dataIssuanceExcel.splice(objIndex, 1);
                    var grid = $("#IssuanceUploadGrid").data("kendoGrid");
                    grid.dataSource.data(this.dataIssuanceExcel);
                }
            })
        },

        SaveIssuance: function () {
            const self = this;
            let IssuanceCreateObject = {
                Issuance: {
                    config: BaseIssuance,
                    createData: this.dataIssuanceExcel.slice()
                }
            };
            //this._createAllItems(NewPartnerobject).then(addnewpartner => {
            //let loader = this.$loading.show();
             self._APICrudPopup("APICrudpopup");
            this.CreateAllItems(IssuanceCreateObject).then(response => {
                console.log(response);
            //self._AlertPopup("Issuance data saved successfully", "success");
             /** AUDIT DOCUMENT UPLOAD **/
            let FileUpload = [];
            let senderObj = {};
            //senderObj.Id = this.count++;
            let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload)
                .then(response => {
                self._AlertPopup("Issuance data saved successfully", "success");
                })
                .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
                })
                .finally(() => {
                //loader.hide();
                });
            /** AUDIT DOCUMENT UPLOAD END */
                this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        },
        ClearForm() {
            this.dataIssuanceExcel = []
            this.displayPage = false;
            this.customerrors=[];
            this.isValid=false;
        },
        
        validateIssuance() {
      let self = this;
        let ProgramApiData=self.withFilter(BaseModelProgram.list);
        let PartnerApiData=self.withFilter(BaseModelPartner.list);
        let ClassApiData=self.withFilter(BaseModelUnitClass.list);
      var chkError = {
        reqProgramID: true,
        reqReceiverID: true,
        reqUnitClass: true,
        reqUnitType: true,
        reqUnitPool: true,
        reqUnit: true,
        vldUnit:true,
        reqVestingType:true
      };
      self.isValid = true;
      self.customerrors=[];
      self.dataIssuanceExcel.forEach((ele, i) => {
        self.Columns = [];
        let programIndex = ProgramApiData.findIndex(f => f.ProgramID == ele.ProgramProgramID)
        if (ele.ProgramProgramID =="" || isNullOrUndefined(ele.ProgramProgramID) || programIndex < 0) 
        {
          self.Columns.push({ column: "ProgramProgramID", row: i });
          if (chkError.reqProgramID) {
            chkError.reqProgramID = false;
            self.customerrors.push(
              "Program ID is Empty or Invalid."
            );
          }
        }
        let pIndex = PartnerApiData.findIndex(f => f.PartnerID == ele.ReceiverReceiverID)
        if (ele.ReceiverReceiverID =="" || isNullOrUndefined(ele.ReceiverReceiverID)||pIndex < 0) {
          self.Columns.push({ column: "ReceiverReceiverID", row: i });
           if (chkError.reqReceiverID) {
            chkError.reqReceiverID = false;
            self.customerrors.push(
              "Partner ID is Empty or Invalid."
            );
          }
        }

        let unitClassIndex = ClassApiData.findIndex(f => f.UnitClass == ele.UnitClass)
        if (ele.UnitClass =="" || isNullOrUndefined(ele.UnitClass) || unitClassIndex < 0) {
          self.Columns.push({ column: "UnitClass", row: i });
           if (chkError.reqUnitClass) {
            chkError.reqUnitClass = false;
            self.customerrors.push(
              "Unit Class is Empty or Invalid."
            );
          }
        }

        let unitTypeIndex = self.dropdowns.UnitType.dataSource.findIndex(f => f.Option == ele.UnitType)
        if (ele.UnitType =="" || isNullOrUndefined(ele.UnitType) ||unitTypeIndex<0) {
          self.Columns.push({ column: "UnitType", row: i });
          if (chkError.reqUnitType) {
            chkError.reqUnitType = false;
            self.customerrors.push(
              "Unit Type is Empty or Invalid."
            );
          }
        }

        let vestingTypeIndex = self.dropdowns.VestingType.dataSource.findIndex(f => f.Option == ele.VestingType)
        if (ele.VestingType =="" || isNullOrUndefined(ele.VestingType) ||vestingTypeIndex<0) {
          self.Columns.push({ column: "VestingType", row: i });
          if (chkError.reqVestingType) {
            chkError.reqVestingType = false;
            self.customerrors.push(
              "Vesting Type is Empty or Invalid."
            );
          }
        }

        let unitPoolIndex = self.dropdowns.UnitPool.dataSource.findIndex(f => f.Option == ele.UnitPool)
        if (ele.UnitPool =="" || isNullOrUndefined(ele.UnitPool) || unitPoolIndex < 0) {
          self.Columns.push({ column: "UnitPool", row: i });
           if (chkError.reqUnitPool) {
            chkError.reqUnitPool = false;
            self.customerrors.push(
              "Unit Pool is Empty or Invalid."
            );
          }
        }
        if (isNullOrUndefined(ele.Unit)||ele.Unit<1) {
          self.Columns.push({ column: "Unit", row: i });
          if (chkError.vldUnit) {
            chkError.vldUnit = false;
            self.customerrors.push(
              "Unit is required and should be greater than 0 ."
            );
          }
        }
        self.Columns.push({ column: "Validation", row: i });

        if (self.Columns.length != 1 && self.isValid) {
          self.isValid = false;
        }
        self.ValidateImportData("IssuanceUploadGrid", self.Columns);
      });
    },

    getInputControls() {
        let self = this;
        let response = self.getLocalInputControls(BaseModelInputControl.list);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
        });
    }
    
    
    },

    mounted() {
    this.getInputControls();
    }
};
</script>


